import { BaseRouteService } from "core/services";

class DocumentTypeRouteService extends BaseRouteService {
    constructor() {
        super("document-types");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields}`, filter);
    }
}

export default DocumentTypeRouteService;